import { Field, NumericInput, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent, WorksheetAssociatedTestSection } from 'Components/Worksheets/Core';
import React from 'react';

let SeparationUsingRelatedWaterContentSection: React.FC<IWorksheetComponent> = () => {
  return (
    <>
      <ListFieldSection heading="Coarse Portion Mass">
        <Field input={<TextOutput />} name="Separation.CoarsePortion.Masses.DryMass" />
        <Field input={<TextOutput />} name="Separation.FinePortion.Masses.WetMass" />
      </ListFieldSection>
      <ListFieldSection heading="Fine Portion Moisture Content" wide>
        <WorksheetAssociatedTestSection
          heading={`Moisture Content`}
          testType="Moisture Content"
          associatedTestModel={{
            measured: true,
          }}
          disabled
          name="Separation.FinePortion.Subspecimen.Masses.AssociatedMoistureContent"
        />
      </ListFieldSection>
      <ListFieldSection>
        <Field input={<TextOutput />} name="Separation.FinePortion.Masses.DryMass" />
        <Field input={<TextOutput />} name="Masses.DryMass" label="Specimen Total Dry Mass" />
      </ListFieldSection>
      <ListFieldSection heading="Fine Portion Subspecimen Mass">
        <NamePrefixModifier appendNamePrefix="Separation.FinePortion.Subspecimen.Masses">
          <Field input={<NumericInput />} name="MassMeasurement.TareMass" />
          <Field input={<NumericInput />} name="MassMeasurement.TareAndWetMass" />
          <Field input={<TextOutput />} name="MassMeasurement.WetMass" />
          <Field input={<TextOutput />} name="DryMass" />
        </NamePrefixModifier>
      </ListFieldSection>
    </>
  );
};

SeparationUsingRelatedWaterContentSection = withInjectedProps(SeparationUsingRelatedWaterContentSection);

export { SeparationUsingRelatedWaterContentSection };
export default SeparationUsingRelatedWaterContentSection;
